exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-4e1bf1fe]{padding:6px 14px;background-color:#007bff;color:#fff;border:none;border-radius:4px;font-size:14px;cursor:pointer}.btn[data-v-4e1bf1fe]:hover{background-color:#0056b3}", ""]);

// exports
